import moment from 'moment';

/**
 * Format Time
 * @param timestamp
 * @returns {*}
 */
const formatTime = timeStr => {
    if (timeStr) {
        const timestamp = timeStr / 1000;
        const date = moment.unix(timestamp).format('YYYY-MM-DD HH:mm');
        return date;
    } else {
        return '';
    }
};
const formatJustTime = timeStr => {
    if (timeStr) {
        const timestamp = timeStr / 1000;
        const date = moment.unix(timestamp).format('YYYY-MM-DD HH:mm:ss');
        return date.split(' ')[1];
    } else {
        return '';
    }
};
const formatDate = timeStr => {
    if (timeStr) {
        const date = moment.unix(timeStr / 1000).format('YYYY-MM-DD');
        return date;
    } else {
        return '';
    }
};

const formatHour = timeStr => {
    if (timeStr) {
        const date = moment.unix(timeStr / 1000).format('HH:mm:ss');
        return date;
    } else {
        return '';
    }
};

const format = (input, pattern = 'YYYY-MM-DD') => {
    if (moment.isMoment(input)) {
        return input.format(pattern);
    } else {
        console.warn(
            '[SCF] Warning because input parameter is not valid moment.'
        );
        return '';
    }
};

const formatTo = (input, to = 'YYYY-MM-DD', pattern = 'YYYY-MM-DD') => {
    if (!moment.isMoment(input)) {
        input = moment(input, pattern);
    }
    return input.format(to);
};

const formatInt = (input, to = 'YYYY-MM-DD') => {
    return moment(input).format(to);
};

export default {
    formatTime,
    formatDate,
    format,
    formatTo,
    formatInt,
    formatJustTime,
    formatHour,
};



// WEBPACK FOOTER //
// ./src/utils/Doc/Date.ts